import { attractionTypeCrudConfig, type AttractionType } from '@/config/objects/attraction-types';
import { CrudFormView, PageContainer } from '@startupquickstart/frontend';
import { useNavigate, useParams } from 'react-router-dom';

/**
 * Attraction Type create/edit form page
 */
export function AttractionTypeFormPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  // If id is 'new', treat as create mode (id = undefined)
  const itemId = id === 'new' ? undefined : id;
  const isEdit = !!itemId;

  /**
   * Handle successful form submission
   */
  const handleSuccess = (attractionType: AttractionType) => {
    // Navigate to the attraction type detail page
    navigate(`/attraction-types/${attractionType.id}`);
  };

  const breadcrumbs = isEdit
    ? [
        { label: 'Home', href: '/' },
        { label: 'Attraction Types', href: '/attraction-types' },
        { label: 'Attraction Type', href: `/attraction-types/${itemId}` },
        { label: 'Edit', current: true },
      ]
    : [
        { label: 'Home', href: '/' },
        { label: 'Attraction Types', href: '/attraction-types' },
        { label: 'Create', current: true },
      ];

  return (
    <PageContainer>
      <CrudFormView
        config={attractionTypeCrudConfig}
        itemId={itemId}
        breadcrumbs={breadcrumbs}
        onSuccess={handleSuccess}
      />
    </PageContainer>
  );
}
